import { type LucideIcon } from "lucide-react";

export function StatCard({ label, value, icon: Icon, hint, accent }: { label: string; value: string; icon: LucideIcon; hint?: string; accent?: "gold" | "primary" | "success" | "danger" }) {
  const accents: Record<string, string> = {
    gold: "text-amber-300 bg-amber-300/10",
    primary: "text-primary bg-primary/10",
    success: "text-emerald-400 bg-emerald-400/10",
    danger: "text-red-400 bg-red-400/10",
  };
  const a = accents[accent ?? "primary"];
  return (
    <div className="glass rounded-2xl p-5">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-widest text-muted-foreground">{label}</span>
        <span className={`grid place-items-center h-8 w-8 rounded-lg ${a}`}><Icon className="h-4 w-4" /></span>
      </div>
      <div className="mt-3 font-mono text-2xl font-semibold">{value}</div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}